import AbstractProvidedClass from "../../../shared/AbstractProvidedClass";

export default class AbstractField extends AbstractProvidedClass {
    field;
    initialized = false;
    isInputField = false;
    styles = [];
    classes = [];
    supportedTypes = ['ellipse', 'rectangle', 'polygon', 'line'];
    showInDrawMode = true;
    isDrawInput = false;

    static setup(provider) {
        return new this(provider);
    }

    parent(parent) {
        this.initialized
            ? this.field.parent(parent)
            : this.parentElement = parent;
        return this;
    }

    style(values) {
        this.initialized
            ? this.field.style(...values)
            : this.styles.push(values);
        return this;
    }

    types(types) {
        this.supportedTypes = types;
        return this;
    }

    class(value) {
        this.initialized
            ? this.field.class(value)
            : this.classes.push(value);
        return this;
    }

    drawInput() {
        this.isDrawInput = true;
        return this;
    }

    setPopulate(func) {
        this.populateFunction = func;
        return this;
    }

    populate(element) {
        if (this.populateFunction === undefined) {
            throw new Error('No populate function defined for field');
        }
        this.populateFunction(element, this.field);
    }

    setElement(element) {
        this.element = element;
        if (this.supportedTypes.includes(element.type)) {
            this.populate(element);
            this.show();
        } else {
            this.hide();
        }
    }

    hideInDrawMode() {
        this.showInDrawMode = false;
        return this;
    }

    setDrawMode(type) {
        if (this.showInDrawMode && this.supportedTypes.includes(type)) {
            this.reset();
            this.show()
        } else {
            this.hide();
        }
    }

    show() {
        this.visible = true;
        this.field.show();
    }

    hide() {
        this.visible = false;
        this.field.hide();
    }

    make() {
        throw new Error('Abstract method');
    }

    reset() {
        throw new Error('Abstract method');
    }

    applyStyles() {
        this.styles.map((values) => this.field.style(...values));
    }

    applyClasses() {
        this.field.class(this.classes.join(' '));
    }

    update() { }
}
